import { createContext, useContext } from "react";
import { ChapterController } from "./chapterController";
import { CourseEditorController } from "./courseEditorController";

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const EditorControllerContext = createContext<CourseEditorController>(null as any);
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const ChapterControllerContext = createContext<ChapterController>(null as any);

export const useEditorController = (): CourseEditorController => useContext(EditorControllerContext);
export const useChapterController = (): ChapterController => useContext(ChapterControllerContext);
